<div class="left-side">
  <div class="text-column">
    <p class="tag">{{ 'onboarding.stepFour.tag' | translate }}</p>
    <p class="title">{{ 'onboarding.stepFour.title' | translate }}</p>

    <div class="cards">
      <app-onboarding-info-card badgeColor="green">
        <actee-icon
          slot="badge"
          name="help"
        />
        <span>{{ 'onboarding.stepFour.cards.helpCenter' | translate }}</span>
      </app-onboarding-info-card>
      <app-onboarding-info-card badgeColor="orange">
        <actee-icon
          slot="badge"
          name="assist"
        />
        <span>{{ 'onboarding.stepFour.cards.contact' | translate }}</span>
      </app-onboarding-info-card>
      <app-onboarding-info-card badgeColor="purple">
        <actee-icon
          slot="badge"
          name="email"
        />
        <span
          >{{ 'onboarding.stepFour.cards.support' | translate }}
          <a
            acteeLink
            class="inline-link"
            rel="noopener noreferrer"
            target="_blank"
            [href]="helpCenterUrl"
            >{{ 'onboarding.stepFour.cards.supportLink' | translate }}</a
          >.</span
        >
      </app-onboarding-info-card>
    </div>
  </div>
</div>

<div class="right-side">
  <img
    ngSrc="/images/onboarding/step-4.svg"
    width="470"
    height="408"
    [alt]="'onboarding.stepFour.imageAlt' | translate"
  />
</div>
